import { cn } from "@/lib/utils"
import { ReactNode } from "react"

interface SettingsHeaderProps {
  title: string
  description?: string | ReactNode
  className?: string
}

/**
 * Reusable settings header component that displays a consistent heading
 * with an optional description in settings pages.
 *
 * The description can be either a simple string or a ReactNode for rich content
 * with links or formatting.
 */
export function SettingsHeader({
  title,
  description,
  className,
}: SettingsHeaderProps) {
  return (
    <div className={cn("space-y-1", className)}>
      <h2 className="text-xl text-card-foreground">{title}</h2>
      {description && (
        <p className="text-sm text-muted-foreground">{description}</p>
      )}
    </div>
  )
}
